import { toast } from "react-toastify";
import Api from "../../../api/axios";
import { Button, Form, Input, Label, Select, StyledImgUpload, Textarea } from "../../../styles";
import { upload } from "../../../assets";
import { convertFile } from "../../../utils/helpers";
import { useEffect, useState } from "react";
import { useUserContext } from "../../../context/user_context";

const Kyb = () => {
      const [issending, setissending] = useState(false);

      const [formField, setformField] = useState({
            cac_name: '',
            cac_number: '',
            id_name: '',
            email: '',
            phone: '',
            address: '',
            bvn: '',
            nin: '',
      });

      const [id_photo, setId_photo] = useState(null);
      const [address, setAddress] = useState(null);
      const [cac_certificate, setCac_certificate] = useState(null);
      const [memorandum, setMemorandum] = useState(null);
      const [reg_status, setReg_status] = useState(null);

      const { businessData, stoken, usertoken, getBusinessData } = useUserContext();

      const {
            btoken,
            cacData,
      } = businessData;
      console.log(businessData);


      // Form Fields
      function handleChange(e) {
            setformField((inputs) => ({
                  ...inputs,
                  [e.target.name]: e.target.value,
            }));
      }
      // Form Field

      function submitFn(e) {
            e.preventDefault();
            if ((
                  formField.cac_name
                  && formField.cac_number
                  && cac_certificate
                  && memorandum
                  && reg_status
            )) {
                  setissending(true);
                  const data = {
                        cac_name: formField.cac_name,
                        cac_number: formField.cac_number,
                        cac_cert_document: cac_certificate,
                        cac_mem_article_document: memorandum,
                        cac_registration_status_document: reg_status,
                        btoken, stoken, usertoken
                  };

                  Api.post(`/settings/verification.kyb.php`, data)
                        .then((res) => {
                              if (res.success === false) {
                                    toast.warn(res.message);
                                    setissending(false);
                              } else {
                                    setissending(false);
                                    toast.success(res.message);
                                    getBusinessData();
                              }
                        })
                        .catch((error) => {
                              setissending(false);
                        });
            } else {
                  setissending(false);
                  toast.warn("Empty Fields !!!");
            }
      }

      function submitFnDirector(e) {
            e.preventDefault();
            if ((
                  formField.name
                  && formField.email
                  && formField.phone
                  && formField.address
                  && formField.bvn
            )) {
                  setissending(true);
                  const data = {
                        name: formField.name,
                        mail: formField.email,
                        phone: formField.phone,
                        address: formField.address,
                        bvn: formField.bvn,
                        nin: formField.nin,
                        btoken, stoken, usertoken
                  };

                  Api.post(`/settings/verification.kyb.directors.php`, data)
                        .then((res) => {
                              if (res.success === false) {
                                    toast.warn(res.message);
                                    setissending(false);
                              } else {
                                    setissending(false);
                                    toast.success(res.message);
                                    getBusinessData();
                              }
                        })
                        .catch((error) => {
                              setissending(false);
                        });
            } else {
                  setissending(false);
                  toast.warn("Empty Fields !!!");
            }
      }

      useEffect(() => {
            getBusinessData();
      }, []);

      return (
            <div className="">
                  <h4 className="my-4 font-bold">
                        Business Verification
                  </h4>

                  {cacData?.status === 'pending' ?
                        <>
                              <p className="my-4 font-normal fs-5 green-text">
                                    Verification is {cacData?.status}
                              </p>
                        </>
                        :
                        <Form onSubmit={(e) => submitFn(e)}>

                              <div className="mx-auto col-md-8">

                                    <div className="justify-content-between row">
                                          <div className="col-md-4">
                                                <Label> CAC Ceritificate Name: </Label>
                                          </div>
                                          <div className="col-md-8">
                                                <Input
                                                      type="text"
                                                      name="cac_name"
                                                      placeholder="Enter CAC name"
                                                      onChange={handleChange}
                                                      value={formField.cac_name}
                                                      required
                                                />
                                          </div>
                                    </div>
                                    <div className="justify-content-between row">
                                          <div className="col-md-4">
                                                <Label> CAC Ceritificate Number: </Label>
                                          </div>
                                          <div className="col-md-8">
                                                <Input
                                                      type="text"
                                                      name="cac_number"
                                                      placeholder="Enter CAC number"
                                                      onChange={handleChange}
                                                      value={formField.cac_number}
                                                      required
                                                />
                                          </div>
                                    </div>
                                    <div className="justify-content-between row">
                                          <div className="col-md-4">
                                                <Label> CAC Certificate: </Label>
                                          </div>
                                          <div className="col-md-8">
                                                <Input
                                                      type="file"
                                                      accept="image/*"
                                                      onChange={(e) => convertFile(e, setCac_certificate)}
                                                />
                                          </div>
                                    </div>
                                    <div className="justify-content-between row">
                                          <div className="col-md-4">
                                                <Label> Momorandum of Article: </Label>
                                          </div>
                                          <div className="col-md-8">
                                                <Input
                                                      type="file"
                                                      accept="image/*"
                                                      onChange={(e) => convertFile(e, setMemorandum)}
                                                />
                                          </div>
                                    </div>
                                    <div className="justify-content-between row">
                                          <div className="col-md-4">
                                                <Label> Registration Status: </Label>
                                          </div>
                                          <div className="col-md-8">
                                                <Input
                                                      type="file"
                                                      accept="image/*"
                                                      onChange={(e) => convertFile(e, setReg_status)}
                                                />
                                          </div>
                                    </div>

                                    <div className="mx-auto mb-4 text-center col-md-12">
                                          <Button
                                                pry
                                                type="submit"
                                                disabled={issending}
                                                className="m-0 w-100 btn"  >
                                                {issending ? 'loading...' : "Submit"}
                                          </Button>
                                    </div>
                              </div>
                        </Form>
                  }

                  <Form onSubmit={(e) => submitFnDirector(e)}>
                        <h4 className="my-4 font-bold">
                              Director’s Verification
                        </h4>
                        <div className="mx-auto col-md-8">
                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> Name on ID: <span>*</span></Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Input
                                                type="text"
                                                name="name"
                                                placeholder="Enter name "
                                                onChange={handleChange}
                                                value={formField.name}
                                                required
                                          />
                                    </div>
                              </div>
                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> Email: <span>*</span></Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Input
                                                type="email"
                                                name="email"
                                                placeholder="Enter email addresss"
                                                onChange={handleChange}
                                                value={formField.email}
                                                required
                                          />
                                    </div>
                              </div>
                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> Phone Number: <span>*</span></Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Input
                                                type="number"
                                                name="phone"
                                                placeholder="Enter phone number"
                                                onChange={handleChange}
                                                value={formField.phone}
                                                required
                                          />
                                    </div>
                              </div>
                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> Address: <span>*</span></Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Textarea
                                                type="text"
                                                name="address"
                                                placeholder="Enter address"
                                                onChange={handleChange}
                                                value={formField.address}
                                                required
                                          ></Textarea>
                                    </div>
                              </div>
                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> BVN: <span>*</span> </Label>

                                    </div>
                                    <div className="col-md-8">
                                          <Input
                                                type="number"
                                                name="bvn"
                                                placeholder="Enter BVN"
                                                onChange={handleChange}
                                                value={formField.bvn}
                                                required
                                          />
                                    </div>
                              </div>

                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> NIN: </Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Input
                                                type="number"
                                                name="nin"
                                                placeholder="Enter NIN"
                                                onChange={handleChange}
                                                value={formField.nin}
                                          />
                                    </div>
                              </div>

                              {/* <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> ID Type: </Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Select
                                                name="id"
                                                onChange={handleChange}
                                                required
                                                value={formField.id}
                                          >
                                                <option value="">Select ID</option>
                                                <option value="nin">NIN</option>
                                                <option value="voters card">Voter's Card</option>
                                                <option value="passport">International Passport</option>

                                          </Select>
                                    </div>
                              </div>

                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> Upload ID: </Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => convertFile(e, setId_photo)}
                                          />
                                    </div>

                              </div>
                              <div className="justify-content-between row">
                                    <div className="col-md-4">
                                          <Label> Proof of Address: </Label>
                                    </div>
                                    <div className="col-md-8">
                                          <Input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => convertFile(e, setAddress)}
                                          />
                                    </div>

                              </div> */}

                              <div className="mx-auto mb-4 text-center col-md-12">
                                    <Button
                                          pry
                                          type="submit"
                                          disabled={issending}
                                          className="m-0 w-100 btn"  >
                                          {issending ? 'loading...' : "Submit"}
                                    </Button>
                              </div>
                        </div>
                  </Form>

            </div>

      );
};

export default Kyb;